export default {
  appInsightsCount: ({ appInsightsCount }) => appInsightsCount,
  appInsights: ({ appInsights }) => appInsights,
  demoAppInsights: ({ demoAppInsights }) => demoAppInsights,
  demoAppInsightsCount: ({ demoAppInsightsCount }) => demoAppInsightsCount,
  currentPage: ({ currentPage }) => currentPage,
  pagesCount: ({ pagesCount }) => pagesCount,
  isAppInsightsLoading: ({ isAppInsightsLoading }) => isAppInsightsLoading,
};
